import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const approaches = ['Los horóscopos generales son demasiado vagos y no consideran tu vibración numérica base.', 'La numerología tradicional te da un número, pero no te dice cómo usarlo para navegar tus ciclos emocionales.', 'Los informes de 50 páginas son tan complejos que terminan archivados sin generar un solo cambio real.', 'Intentar encajar en moldes de éxito ajenos solo te ha llevado al agotamiento y a la duda constante sobre tus capacidades.'];
export function FailedApproaches() {
  return <section className="py-24 bg-trino-cream relative" data-id="element-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl sm:text-4xl font-bold font-serif text-trino-burgundy mb-4" data-id="element-15">
            Por qué lo que has intentado no funcionó
          </h2>
          <div className="w-24 h-1 bg-trino-gold mx-auto rounded-full" data-id="element-16"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-17">
          {approaches.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-trino-peach/30 flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-18">
              <div className="flex-shrink-0 mt-1" data-id="element-19">
                <XCircle className="w-6 h-6 text-trino-coral" data-id="element-20" />
              </div>
              <p className="text-trino-dark/80 leading-relaxed" data-id="element-21">{text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}